import {useDroppable} from "@dnd-kit/core";
import './styles.css';
import {Text} from 'atmosfair-ui'
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import CreateJourneyFromTravelComponentsCardGroup
    from "../card-list/create-journey-from-travel-components-card-group/CreateJourneyFromTravelComponentsCardGroup";
import React, {useEffect, useState} from "react";
import {
    COMMON_COLOR,
    CreateJourneyFromTravelComponentsDayCardPropsContext,
    CreateJourneyFromTravelComponentsDayCardPropsContextProps,
    JourneyDayCardProps
} from "../../common";
import "../../styles.css"
import {disableDroppableOnLastDayOfJourney} from "../../common/common";

export interface CreateJourneyFromTravelComponentsDayCardProps extends JourneyDayCardProps {
    hasExactDates: boolean,
}

const CreateJourneyFromTravelComponentsDayCard = ({
                                                      allActivities,
                                                      droppableZoneId,
                                                      day,
                                                      onActivityArrowUp,
                                                      onActivityArrowDown,
                                                      onActivityDelete,
                                                      isRecalculatingActivityEmissions,
                                                      journeyDurationInDays,
                                                      draggingActivity,
                                                      hasExactDates,
                                                  }: CreateJourneyFromTravelComponentsDayCardProps) => {
    const [createJourneyFromTravelComponentsDayCardPropsContext, setCreateJourneyFromTravelComponentsDayCardPropsContext] =
        useState<CreateJourneyFromTravelComponentsDayCardPropsContextProps>({
            day,
            allActivities,
            droppableZoneId,
            isRecalculatingActivityEmissions,
            activitiesAtDay: allActivities,
            onActivityArrowUp,
            onActivityDelete,
            onActivityArrowDown,
            journeyDurationInDays,
            draggingActivity,
            hasExactDates,
        })
    let isDroppableDisabled = disableDroppableOnLastDayOfJourney(draggingActivity, day, journeyDurationInDays)
    const {setNodeRef, isOver} = useDroppable({id: droppableZoneId, disabled: isRecalculatingActivityEmissions})
    const {t} = useTranslation()

    useEffect(() => {
        setCreateJourneyFromTravelComponentsDayCardPropsContext({
            day,
            allActivities,
            droppableZoneId,
            isRecalculatingActivityEmissions,
            activitiesAtDay: allActivities,
            onActivityArrowUp,
            onActivityDelete,
            onActivityArrowDown,
            journeyDurationInDays,
            draggingActivity,
            hasExactDates
        })
    }, [
        day,
        droppableZoneId,
        isRecalculatingActivityEmissions,
        allActivities,
        onActivityArrowUp,
        onActivityDelete,
        onActivityArrowDown,
        journeyDurationInDays,
        hasExactDates,
    ]);

    const _setClassesForDroppableContainer = () => {
        if (isDroppableDisabled) return ""
        if (isOver) return 'dnd-day-card-is-over'
        return ""
    }

    return <CreateJourneyFromTravelComponentsDayCardPropsContext.Provider
        value={createJourneyFromTravelComponentsDayCardPropsContext}>
        <div
            className={clsx(
                'create-journey-from-travel-components-day-card-container',
                'create-journey-from-travel-components-box'
            )}>
            <Text
                color={COMMON_COLOR}
                style={{textAlign: 'left', width: '100%'}}
                variant={'headlineMedium'}>{`${t('GENERAL.DAY')} ${day}`}</Text>
            <ul
                ref={setNodeRef}
                className={clsx('create-journey-from-travel-components-day-card-unordered-list', _setClassesForDroppableContainer())}>
                <CreateJourneyFromTravelComponentsCardGroup
                    isInitialGroup={false}
                    droppableDisabled={isDroppableDisabled}
                    isOver={isOver}/>
            </ul>
        </div>
    </CreateJourneyFromTravelComponentsDayCardPropsContext.Provider>
};

export default CreateJourneyFromTravelComponentsDayCard;